import React from "react";
import { Routes, Route, useParams } from "react-router-dom";
import EnhancedProductList from "./ProductList/EnhancedProductList";
import EnhancedProductForm from "./ProductForm/EnhancedProductForm";
import ProductDetails from "./ProductDetails/ProductDetails";
import { useDispatch, useSelector } from "react-redux";
import { getProductByIdThunk } from "store/thunks/adminProductThunks";
import { MultiProductCreator } from "./MultiProductCreator";

const ProductRoutes = () => {
  return (
    <Routes>
      <Route path="/" element={<EnhancedProductList />} />
      <Route path="/new" element={<EnhancedProductForm mode="add" />} />
      <Route path="/new-bulk" element={<MultiProductCreator />} />
      <Route path="/edit/:id" element={<ProductEditWrapper />} />
      <Route path="/:id" element={<ProductDetails />} />
    </Routes>
  );
};

// Wrapper for edit mode to load product data
const ProductEditWrapper = () => {
  const { id } = useParams();
  const dispatch = useDispatch();
  const { product, loading } = useSelector((state) => state.adminProduct);

  React.useEffect(() => {
    dispatch(getProductByIdThunk(id));
  }, [id, dispatch]);

  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
      </div>
    );
  }

  return <EnhancedProductForm initialData={product} mode="edit" />;
};

export default ProductRoutes;
